import "./Checkbox.scss";

interface CheckboxProps {
  id: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  marginTop?: string;
  className?: string;
  disabled?: boolean;
}

const Checkbox = ({
  id,
  checked,
  onChange,
  marginTop,
  className = "",
  disabled = false,
}: CheckboxProps) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!disabled) {
      onChange(e.target.checked);
    }
  };

  const checkboxClasses = [
    "checkbox",
    marginTop ? `checkbox--margin-top` : "",
    disabled ? "checkbox--disabled" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div
      className={checkboxClasses}
      style={marginTop ? { marginTop } : undefined}
    >
      <input
        type="checkbox"
        id={id}
        checked={checked}
        onChange={handleChange}
        className="checkbox__input"
        disabled={disabled}
      />
      <label
        htmlFor={id}
        className={`checkbox__label ${checked ? "checked" : ""}`}
      ></label>
    </div>
  );
};

export default Checkbox;
